namespace advisorop.components.servicer {

    // Maintenance widget: grid of all investors (active + soft-deleted) with multi-select
    // checkboxes and a button that queues a Salesforce re-sync for the selected rows.
    class AdminInvestorSyncGridController {

        public investors: Array<domains.IAdminInvestorSyncRow> = [];
        public dg: DevExpress.ui.dxDataGridOptions;
        public dataGrid: DevExpress.ui.dxDataGrid;
        public loading: boolean = false;
        public syncing: boolean = false;

        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {

            this.dg = {
                bindingOptions: {
                    dataSource: "vm.investors"
                },
                onInitialized: (e) => {
                    this.dataGrid = e.component;
                },
                keyExpr: "id",
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                rowAlternationEnabled: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                wordWrapEnabled: true,
                noDataText: "No investors",
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: { visible: true, width: 260, placeholder: "Search..." },
                paging: { pageSize: 25 },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [25, 50, 100],
                    showInfo: true
                },
                selection: {
                    mode: "multiple",
                    showCheckBoxesMode: "always",
                    selectAllMode: "allPages"
                },
                columns: [
                    { dataField: "name", caption: "Name" },
                    { dataField: "advisorsStr", caption: "Advisor(s)" },
                    { dataField: "analystStr", caption: "Analyst" },
                    { dataField: "statusDescription", caption: "Status", width: 110 },
                    { dataField: "hasSalesforceLink", caption: "SF Linked", dataType: "boolean", width: 90 },
                    { dataField: "salesforceContactId", caption: "SF Contact Id", visible: false },
                    { dataField: "analystLastSyncedAt", caption: "Analyst Synced", dataType: "datetime", visible: false }
                ]
            };
        }

        $onInit(): void {
            this.loadInvestors();
        }

        loadInvestors(): void {
            this.loading = true;
            this.servicerService.getInvestorsForAdminSync()
                .then(response => {
                    this.investors = response.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    toastr.error("Failed to load investors" + (err && err.status ? " (" + err.status + ")" : ""));
                });
        }

        syncSelected(): void {
            var selected = this.dataGrid
                ? <Array<domains.IAdminInvestorSyncRow>>this.dataGrid.getSelectedRowsData()
                : [];

            if (!selected || selected.length == 0) {
                toastr.warning("Select at least one investor.");
                return;
            }

            var ids = selected.map(s => s.id);
            this.syncing = true;
            this.servicerService.syncInvestorsWithSalesforce(ids)
                .then(response => {
                    this.syncing = false;
                    var result = response.data;
                    toastr.success(result.message || ("Queued " + result.enqueued + " investor(s)."));
                    if (this.dataGrid) {
                        this.dataGrid.clearSelection();
                    }
                })
                .catch(err => {
                    this.syncing = false;
                    toastr.error("Sync failed" + (err && err.status ? " (" + err.status + ")" : ""));
                });
        }
    }

    class AdminInvestorSyncGrid implements ng.IComponentOptions {

        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = AdminInvestorSyncGridController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/admin-investor-sync-grid.html';
        }
    }
    angular.module(Constants.APP).component("adminInvestorSyncGrid", new AdminInvestorSyncGrid());
}
